<template>
  <!-- eslint-disable  -->
  <div class="w-100" >
    <!-- START Navigation and related information -->
    <!-- <div id="nav-info" role="navigation" class="container-fluid fixed-top w-100 px-0">
      <section-navigation :homePageData="homePageData"></section-navigation>
    </div> -->
    <!-- <div  role="main" :class="{'quote-panel-open': quotePanelStatus, 'quote-panel-close': !quotePanelStatus}"> -->
        <!-- START Content Wrapper -->
    <div class="row no-gutters mx-0 home" >
      <div class="col">

        <!-- BIND PAYMENT ERROR MSG-->
        <div v-if="!showError && homePageData.Error && this.homePageData.fields !== null" class="alert alert-danger">
          <div class="my-0 w-100" role="alert">
            <div class="row no-gutters">
              <div class="d-inline-block pr-2">
                <i class="fa fa-icon-exclamation-circle"></i>
              </div>
              <div class="col d-inline-block my-auto payment-error p-0" aria-level="3">
                <strong>Payment Error: </strong>{{homePageData.Error.Message}}
              </div>
            </div>
          </div>
        </div>

        <!-- RATE CALL ERROR MSG-->
        <div class="row px-4" v-if="this.homePageData.fields === null" id="errorMsg">
          <div class="col-12 pt-3 pb-2 mb-3 text-white text-left bg-danger" aria-level="3">
            <h1>
              <i class="fa fa-icon-exclamation-circle"></i> We were unable to proceed due to an error.
            </h1>
          </div>
        </div>
        <div class="row px-4" v-if="$store.getters.getRcHomeStatusError" id="errorMsg">
          <div class="col-12 pt-3 pb-2 mb-3 mt-3 text-white text-center bg-danger" aria-level="3">
             <h1>{{ $store.getters.getRcHomeStatusErrorData }}</h1>
          </div>
        </div>
        <div class="row no-gutters">
          <!----LEFT : Home Carrier Details START--->
          <!----Home Carrier Rate Box START--->
          <div v-if="homeCarrierFinalRateSection && homeCarrierFinalRateSection.premium_amount" class="col-12 mx-auto">
            <!-- 2 COL: RATE & QUOTE-->
            <div class="row">

              <!-- LEFT COL: RATE-->
              <div class="col-12 col-md-6 pr-4">
                <!-- HEADER -->
                <div class="bg-green rounded-top">
                  <h3 class="text-center text-white py-2 mb-0">Home - Final Rate</h3>
                </div>
                <!-- BODY -->
                <div class="border-green rounded-bottom border-thick">
                <div class="carrier-logo mx-auto text-center mt-2 mb-0">
                  <img :src="this.homeCarrierFinalRateSection.logo_path" style="max-width: 8rem;">
                  </div>
                  <!-- FINAL RATE -->
                  <div class="final-rate mx-auto text-center text-primary font-weight-bold">
                    {{ this.homeCarrierFinalRateSection.premium_amount | currency-filter }}
                  </div>
                  <!-- FINAL RATE TERM -->
                  <div class="text-center smaller-font-content text-gray">{{ this.homeCarrierFinalRateSection.policy_term }}</div>
                  <!-- RATE DISCLAIMER -->
                  <div class="text-center smaller-font-content text-danger-checkout my-2 mx-4">
                    {{ this.homeCarrierFinalRateSection.blurb }}
                  </div>
                </div>
              </div>

              <!-- RIGHT COL: QUOTE-->
              <div class="col-12 col-md-6 px-4">
                <!-- HEADER -->
                <h3 class="text-center text-gray py-2">Original Quoted Rate</h3>
                <!-- QUOTE -->
                <div class="quote text-center text-gray font-weight-bold">{{ this.homeCarrierFinalRateSection.original_premium_amount | currency-filter }}</div>
                <!-- QUOTE TERM -->
                <div class="text-center smaller-font-content text-gray">{{ this.homeCarrierFinalRateSection.original_policy_term }}</div>
                <!-- ADJUSTMENTS -->
                <div class="quote-adjust smaller-font-content text-gray mt-3" v-html="this.homeCarrierFinalRateSection.premium_adjustment_reason">
                </div>
              </div>

            </div>
          </div>
          <!----Home Carrier Rate Box END--->
          <!--------Payment Options START------------->              
          <div v-if="homePaymentPlanFields && homePaymentPlanFields.length > 0" class="col-12 pt-4">
            <div class="shadow-sm">
              <!-- HEADER -->
              <b-card no-body>
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.HomePaymentOptions variant="primary">
                    <span class="card-heading">
                      <span class="fas fa-home mr-1"></span>
                      Payment Options
                    </span>
                  <span data-v-87cda704="" class="toggle-icon">
                    <i data-v-87cda704="" class="toggle-down fas fa-b-angle-down "></i>
                    <i data-v-87cda704="" class="toggle-up fas fa-b-angle-up"></i>
                  </span>
                </b-button>
                </b-card-header>
                <b-collapse id="HomePaymentOptions" visible accordion="HomePaymentOptions" role="tabpanel">
                  <b-card-body>
                    <b-card-text>
                      <!--PAYMENT OPTION ERROR BLOCK-->
                      <div class="row mx-0 mt-2 no-gutters" v-show="errors.has('QTE_PRP_BillPlan')">
                        <div class="col-12 d-inline-block">
                          <div class="small mt-3 mb-1 p-2 form-error">
                              <span><strong>Required:</strong> Please select a payment option.</span>
                          </div>
                        </div>
                      </div>
                      <!--PAYMENT DESCRIPTION-->
                      <div class="row mx-0 mt-2 no-gutters">
                        <div class="col-12 d-inline-block text-faint-gray">
                          <span class="star">*</span>If the customer is ready to buy, proceed with the following payment options. <template v-if="(this.homePageData.page_name.includes('nwid'))">“Installment” options are non-auto pay and require a one-time payment due today, and future payments are submitted through your Nationwide online account.</template>
                        </div>
                      </div>
                      <!--PAYMENT PLAN OPTIONS -->
                      <div class="w-100" v-for="(item, key) in homePaymentPlanFields" :key="key">
                        <template v-if="newHeader(key, homePaymentPlanFields, item.sub_section)">
                          <!--TABLE HEADER-->
                          <div class="row mt-2 px-2 py-1 bg-homeback text-dark-gray no-gutters">
                            <div class="col-12" role="heading" aria-level="4">{{ item.sub_section }}</div>
                          </div>
                          <!--TABLE COLUMN HEADER-->
                          <div class="row py-1 smaller-font-content font-weight-bold bg-light text-center text-dark-gray no-gutters">
                            <div class="col border-right">Payment Option</div>
                            <div class="col-2 border-right">Savings</div>
                            <div class="col-2 border-right">You Pay Today</div>
                            <div class="col-2 border-right">Future Payments</div>
                            <div class="col-2">Total<template > Price</template></div>
                          </div>
                        </template>

                        <div id="pay-full-1" class="row py-1 payment-item text-faint-gray no-gutters">
                          <!--OPTION NAME-->
                          <div class="col border-right smaller-font-content font-weight-bold text-black">
                            <form-block :formdata='item'  class="form-group"></form-block>
                          </div>
                          <!--SAVINGS-->
                          <div class="col-2 border-right text-center">
                            <div class="text-green font-weight-bold">{{ item.savings | currency-filter }}</div>
                            <div class="text-gray sm-txt">Discount</div>
                          </div>
                          <!--PAY TODAY-->
                          <div class="col-2 border-right text-black text-center">
                            <div class="font-weight-bold">{{ item.downpayment | currency-filter }}</div>
                            <div  v-if="item.downpayment_subtext" class="text-gray sm-txt">{{ item.downpayment_subtext }}</div>
                          </div>
                          <!--FUTURE PAYMENTS-->
                          <div class="col-2 border-right text-center">
                            <div v-if="item.numpayments > 0" class="text-gray sm-txt">{{ item.numpayments }} Payments</div>
                            <div class="text-faint-gray my-1"><strong>{{ item.installment_amount | currency-filter }}</strong></div>
                            <div  v-if="item.installment_amount_subtext" class="text-gray sm-txt">{{ item.installment_amount_subtext }}</div>
                          </div>
                          <!--TOTAL-->
                          <div class="col-2 text-center">
                            <div class="text-primary font-weight-bold text-qs-blue">{{ item.total_cost | currency-filter }}</div>
                            <div  v-if="item.total_cost_subtext" class="text-gray sm-txt">{{ item.total_cost_subtext }}</div>
                            <button v-if="item.bill_plan" @click="openBreakdownModal(`breakdownHeader-${item.bill_plan.bill_plan_id}`)" type="button" class="cursorBox btn-sm btn-outline-primary d-inline-block smaller-font-content center mt-2">Breakdown</button>
                          </div>
                        </div>
                        <modal :name="`breakdownHeader-${item.bill_plan.bill_plan_id}`" height="auto" @opened="modalOpened('breakdownModal')" :scrollable="true" v-if="item.bill_plan" focusTrap="true">
                          <Trap>
                          <div class="breakdown-modal-top pt-2 pl-3 pr-2 product-section-heading text-white">
                            <h3 class="breakdown-modal-header">{{ item.label }}</h3>
                            <a href="JavaScript:void(0);" id="breakdownModal" name="breakdownModal" ref="breakdownModal" @click.prevent="closeBreakdownModal(`breakdownHeader-${item.bill_plan.bill_plan_id}`)" class="cursorBox fa-stack uniform-icon-breakdown">
                              <span class="fas fa-circle fa-stack-2x" style="color:#fff"></span>
                              <span class="fas fa-times fa-stack-1x" style="color:#1C3664"></span>
                            </a>
                          </div>
                          </Trap>
                          <img :src="item.bill_plan.logo_url" class="carrier-logo pl-3 my-2">
                          <div class="pl-3 pr-3 pb-3">
                            <table class="table table-sm table-striped mb-0 w-100">
                              <thead class="blueWhiteHeaderFooter smaller-font-content ">
                                <tr>
                                  <th scope="col">Installment</th>
                                  <th scope="col">Date</th>
                                  <th scope="col">Amount</th>
                                </tr>
                              </thead>
                              <tbody class="breakdown-table-body">
                                <tr v-for="(installment, installmentKey) in item.bill_plan.bill_plan_installments" :key="installmentKey">
                                  <td>{{ installment.installment_name }}</td>
                                  <td>{{ installment.installment_date }}</td>
                                  <td>{{ installment.amount}}</td>
                                </tr>
                              </tbody>
                              <tfoot class="blueWhiteHeaderFooter product-section-heading text-white">
                                <tr>
                                  <td></td>
                                  <td style="text-align:right;">Total:</td>
                                  <td>{{ item.bill_plan.bill_plan_total}}</td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </modal>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <!-- <div class="py-2 pl-3 my-2 product-section-heading text-white rounded-top" role="heading" aria-level="3">Payment Options</div> -->
              
            </div>
          </div>
          <!--------Payment Options END------------->
          <!------Billing Information START-->              
          <div v-if="homeBllingInformationSection" class="col-12">

            <!--TODAYS PAYMENT - BILLING INFORMATION-->
            <div class="shadow-sm">
              <!-- HEADER -->
              <b-card no-body>
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.HomeBillingInfo variant="primary">
                    <span class="card-heading">
                      <span class="fas fa-home mr-1"></span>
                      Billing Information
                  </span>
                  <span data-v-87cda704="" class="toggle-icon">
                    <i data-v-87cda704="" class="toggle-down fas fa-b-angle-down "></i>
                    <i data-v-87cda704="" class="toggle-up fas fa-b-angle-up"></i>
                  </span>
                </b-button>
                </b-card-header>
                <b-collapse id="HomeBillingInfo" accordion="HomeBillingInfo" role="tabpanel">
                  <b-card-body>
                    <b-card-text>
                      <div class="row w-100 mx-0 no-gutters">
                        <!--LEFT COL: FORM-->

                        <!--REPLACE: Form Placeholders-->
                        <div class="col-12 col-md-6 pr-2">
                          <template v-for="(item, key) in homePageFieldsArray" >
                              <!--SUB HEADER-->
                            <div :key="key" v-if="item.section == 'Billing Information'">
                              <div v-if="newHeader(key, homePageFieldsArray, item.sub_section)" class="row mx-0 my-2 py-1 product-section-heading text-white" :key="`${key}2`">
                                <div class="col-12" role="heading" aria-level="4">{{ item.sub_section }}</div>
                              </div>
                              <form-block :formdata='item' :vgsStatus='homeVgsStatus' class="form-group" :key='key'></form-block>
                            </div>
                          </template>
                        </div>

                        <!--RIGHT COL: TOTAL AMOUNT-->
                        <div class="col-12 col-md-6 pl-2">
                          <template v-for="(item, key) in homeCarrierPaymentInformationSection">
                            <!-- HEADER -->
                            <div :key="key" class="rounded-top" :class="{'bg-green':!isBlue(item.section),'bg-primary':isBlue(item.section)}">
                              <h3 class="text-center text-white py-2 mb-0">{{ item.section }}</h3>
                            </div>
                            <!-- BODY -->
                            <div :key="`${key}2`" class="rounded-bottom border-thick pb-2 mb-3" :class="{'border-green':!isBlue(item.section),'border-primary':isBlue(item.section)}">
                              <!-- FINAL RATE -->
                              <!--Dynamic: Amount due today for selected payment option-->
                              <div class="final-rate mx-auto text-center text-primary font-weight-bold">
                                {{ item.payment_amount | currency-filter }}
                              </div>
                              <!-- FINAL RATE TERM -->
                              <!--Pay in Full-->
                              <div class="text-center smaller-font-content" v-html="item.blurb"></div>
                            </div>
                          </template>
                        </div>

                        <!-- CONFIRM & CONSENT NOTICE -->
                        <div class="d-flex justify-content-center mx-auto my-3 w-100">
                          <div class="alert alert-warning my-0 py-2 w-100" role="note">
                            <div class="row no-gutters">
                              <div class="d-inline-block pr-2 my-auto">
                                <img width="25px" height="25px" src="../../../assets/exclamation-circle-yellow-new.svg" alt="info">
                              </div>
                              <div class="col d-inline-block my-auto smaller-font-content">
                                <p class="mb-0 text-dark-gray"><strong>Confirm Payment Information:</strong> Confirm the amounts of today’s payment and any future monthly payments with the customer.</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- CONFIRM & CONSENT NOTICE -->

                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
          <!------Billing Information END-->
          
          <!---Checkout Section Start-->
          <div v-if="homeCheckoutSection" class="col-12">
            <div class="shadow-sm">
              <b-card no-body>
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.homeCheckoutSection variant="primary">
                    <span class="card-heading">
                      <span class="fas fa-home mr-1"></span>
                      Billing Information
                    </span>
                    <span data-v-87cda704="" class="toggle-icon">
                      <i data-v-87cda704="" class="toggle-down fas fa-b-angle-down "></i>
                      <i data-v-87cda704="" class="toggle-up fas fa-b-angle-up"></i>
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse id="homeCheckoutSection" accordion="homeCheckoutSection" role="tabpanel">
                  <b-card-body>
                    <b-card-text>
                      <div class="row w-100  mx-3">
                        <div class="col-11 w-60 alert alert-primary  py-2  .mb-4" role="note">
                          <div class="row no-gutters">
                            <div class="d-inline-block pr-2 my-auto">
                              <img width="20px" height="20px" src="../../../assets/info-circle-blue.svg" alt="info">
                            </div>
                            <div class="col d-inline-block my-auto smaller-font-content" v-html="homeInfoContent()"></div>
                            <!--REPLACE: Form Placeholders-->
                          </div>
                        </div>
                      </div>
                      <div class="d-flex  mx-3 justify-content-center " v-if="homePdfLinkCov && homePdfLinkCov[0]">
                        <!--Safeco QuoteSummaryUrl-->
                        <button v-if="homePdfLinkCov && homePdfLinkCov.length > 1 && homePdfLinkCov[0]"type="button" class="btn mb-2 mr-3 btn-btn btn-outline-primary" @click="homeRedirectToCoverage(homePdfLinkCov[0].field_value)" role="button">{{homePdfLinkCov[0].label}}</button>
                        <!--Nationwide Carrier URL-->
                        <button v-if="homePdfLinkCov && homePdfLinkCov.length === 1 && homePdfLinkCov[0]" type="button" class="btn mb-2 btn-btn btn-primary" @click="homeRedirectToCoverage(homePdfLinkCov[0].field_value)" role="button">{{homePdfLinkCov[0].label}}
                          <i class="fa fa-open-in-new ml-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                              <path d="M9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8H12.6667V12.6667Z" fill="currentColor"/>
                            </svg>
                          </i>
                        </button>
                        <!--Safeco Carrier URL-->
                        <button v-if="homePdfLinkCov && homePdfLinkCov[1]" type="button" class="btn mb-2 btn-btn btn-primary" @click="homeRedirectToCoverage(homePdfLinkCov[1].field_value)" role="button">{{homePdfLinkCov[1].label}}
                          <i class="fa fa-open-in-new ml-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                              <path d="M9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8H12.6667V12.6667Z" fill="currentColor"/>
                            </svg>
                          </i>
                        </button>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>              
            </div>
            <!--REPLACE: Form Placeholders-->
          </div>
          <!---Checkout Section End-->
          <!------Acknowledgements START-->
          <div class="col-12" v-if="homeAcknowledgementSection">
            <div class="shadow-sm">
              <b-card no-body>
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.HomeAcknowledgements variant="primary">
                    <span class="card-heading">
                      <span class="fas fa-home mr-1"></span>
                      Acknowledgements
                  </span>
                  <span data-v-87cda704="" class="toggle-icon">
                    <i data-v-87cda704="" class="toggle-down fas fa-b-angle-down "></i>
                    <i data-v-87cda704="" class="toggle-up fas fa-b-angle-up"></i>
                  </span>
                </b-button>
                </b-card-header>
                <b-collapse id="HomeAcknowledgements" accordion="HomeAcknowledgements" role="tabpanel">
                  <b-card-body>
                    <b-card-text>
                      <template v-for="(item, qKey) in homePageFieldsArray">
                          <div v-if="item.section === 'Coverage Summary & Approval' && item.field_type !== 'label'" :key='qKey'>
                            <form-block :formdata='item' class="form-group"></form-block>
                          </div>
                      </template>
                      <!-- bottom Instruction SECTION -->
                      <div class="d-flex justify-content-center mx-auto mt-3" v-if="homeblurbs.formbottom && homeblurbs.formbottom.visible">
                        <div class="alert alert-primary my-0 py-2" role="note">
                          <div class="row no-gutters">
                            <div class="d-inline-block pr-2 my-auto">
                              <img width="25px" height="25px" src="../../../assets/info-circle-blue.svg" alt="info">
                            </div>
                            <div class="smaller-font-content d-inline-block my-auto" v-html="homeblurbs.formbottom.content"></div>
                          </div>
                        </div>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>  
          </div>
          <!------Acknowledgements END-->
          <!------Coverage Summary START------>
          <div v-if="!showError && homePageData.fields && homePageData.fields.length > 0" class="col-12">
            <div class="shadow-sm ">
              <b-card no-body>
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.HomeCoverages variant="primary">
                    <span class="card-heading">
                      <span class="fas fa-home mr-1"></span>
                      Coverage Summary & Approval
                  </span>
                  <span data-v-87cda704="" class="toggle-icon">
                    <i data-v-87cda704="" class="toggle-down fas fa-b-angle-down "></i>
                    <i data-v-87cda704="" class="toggle-up fas fa-b-angle-up"></i>
                  </span>
                </b-button>
                </b-card-header>
                <b-collapse id="HomeCoverages" accordion="HomeCoverages" role="tabpanel">
                  <b-card-body>
                    <b-card-text>
                      <!-- 2 COL: SUMMARY & APPROVAL -->
                      <div class="row no-gutters">
                        <!-- LEFT COL: COVERAGE SUMMARY-->
                        <div class="col-12">
                          <!-- CONFIRM & CONSENT NOTICE -->
                          <div class="d-flex justify-content-center w-100">
                            <div class="alert alert-warning my-0 py-2 w-100" role="note">
                              <div class="row no-gutters">
                                <div class="d-inline-block pr-2 my-auto">
                                  <img width="25px" height="25px" src="../../../assets/exclamation-circle-yellow-new.svg" alt="info">
                                </div>
                                <div class="col d-inline-block my-auto smaller-font-content">
                                  <p class="mb-0 text-dark-gray"><strong>Confirm Policy Details:</strong> Please confirm the following policy details with the customer. Coverages that are not mentioned are either not offered by the carrier or they were declined by the policyholder.</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- CONFIRM & CONSENT NOTICE -->
                          <!-- KY NO FAULT COVERAGE INFORAMTION -->
                          <div class="d-flex justify-content-center w-100 mt-3" v-if="homeblurbs.formCoverageHelp && homeblurbs.formCoverageHelp.visible">
                            <div class="alert alert-primary my-0 py-2 w-100" role="note">
                              <div class="row no-gutters">
                                <div class="d-inline-block pr-2 my-auto">
                                  <img width="25px" height="25px" src="../../../assets/info-circle-blue.svg" alt="info">
                                </div>
                                <div class="col d-inline-block my-auto smaller-font-content" v-html="homeblurbs.formCoverageHelp.content"></div>
                              </div>
                            </div>
                          </div>
                          <!-- KY NO FAULT COVERAGE INFORAMTION -->
                          <!--CARRIER LOGO-->
                            <!-- CARRIER LOGO TODO NUTAN REMOVE-->
                            <div class="row mx-0 mb-1 no-gutters" v-if="this.homeCarrierFinalRateSection && this.homeCarrierFinalRateSection.logo_path">
                              <div class="carrier-logo col-6 col-sm-3  mt-2 mb-0">
                                <img :src="this.homeCarrierFinalRateSection.logo_path" style="max-width: 8rem;">
                              </div>
                            </div>
                          <!-- <div class="mx-3 mt-4 mb-3">232333
                            <img height="auto" width="150px" :src="$store.getters.getRc2LogoURL" />
                          </div> -->

                          <div class="row mx-0 mb-1 smaller-font-content no-gutters">
                            <div class="col-6 col-sm-3 font-weight-bold">Policy Start Date</div>
                            <div class="col-6 col-sm-9">{{getPolicyStartDate()}}</div>
                          </div>
                          <input-link-button-list :pdfLinkCovData="homePdfLinkCov"></input-link-button-list>
                          <div class="mt-3">
                            <!--SUB HEADER-->
                            <template  v-if="homePropCov.length > 0">
                              <div class="py-1 pl-3 mb-2  text-dark-gray bg-homeback " role="heading" aria-level="4">Property Coverages</div>
                              <!--Liability-->
                              <template v-for="(pData, pKey) in homePropCov">
                                <div class="row mx-0 mb-2 smaller-font-content" :key="pKey+'homePropCov'" >
                                    <div class="col-6 col-md-4 col-xl-6 font-weight-bold text-dark-gray">{{pData.label}}</div>
                                    <div class="col-6 col-md-8 col-xl-6 text-dark-gray" >{{pData.text}}</div>
                                </div>
                              </template>
                            </template>
                            <!--SUB HEADER-->
                            <template  v-if="homePropEndsmt.length > 0">
                              <div class="py-1 pl-3 mt-3 text-dark-gray bg-homeback " role="heading" aria-level="4">Property Endorsement</div>

                              <template v-for="(propData, propKey) in homePropEndsmt">
                                <div class="row mx-0 mb-2 smaller-font-content" :key="propKey+'propKey'" >
                                    <div class="col-6 col-md-4 col-xl-6 font-weight-bold text-dark-gray">{{propData.label}}</div>
                                    <div class="col-6 col-md-8 col-xl-6 text-dark-gray" >{{propData.text}}</div>
                                </div>
                              </template>
                            </template>
                          </div>
                        </div>                    
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
          <!------Coverage Summary END------>
          <!----LEFT : Home Carrier Details END--->
        </div>
        <!-- 2 COL: RATE & INCIDENTS-->
        <div :class="{'row' : true, 'my-3' : this.homePageData.fields === null}" v-if="showError">

          <div id="error-next-step-container" v-if="this.homePageData.fields === null || homePaymentPlanFields.length == 0" class="col-12">
            <bundle-carrier-error :errorData="homeBundleCarrierError"></bundle-carrier-error>
          </div>
          <!-- LEFT COL: RATE-->
       </div>        
      </div>
    <!-- </div> -->
  </div>
  <!-- Bound Policy Alert -->
  <!-- <form-alerts v-if="$store.state.buttonState.quoteSummaryData && $store.state.buttonState.quoteSummaryData.quote_status === 'Bound'" :homePageData="policyBindError" class="policy-bound-alert"></form-alerts> -->
  </div>
  <!-- END Content Wrapper -->
</template>
<script>
/* eslint-disable */
import moment from 'moment';
import Trap from 'vue-focus-lock';
import { loadVGSCollect } from '@vgs/collect-js';
import FormAlerts from '../../presentational/alerts/FormAlerts';
import FormBlock from '../../presentational/FormBlock';
import InputLinkButtonList from '../../interactive/InputLinkButtonList';
// import SectionNavigation from '@/components/presentational/widgets/SectionNavigation';
import fetchData from '../../../services/fetchData';
import fallbackDataRc3 from '../../../../config/admin/fallbackDataRc3';
import { rulesMixin } from '../../../mixins/rulesMixin';
import { pageMixin } from '../../../mixins/pageMixin';
import common from '../../../services/common';
import BundleCarrierError from './BundleCarrierError';


export default {
  mixins: [pageMixin, rulesMixin],
  inject: ['$validator'],
  data() {
    return {
      homeAcknowledgementSection: false,
      homeBllingInformationSection:false,
      homeCheckoutSection: false,
      homePdfLinkCov: [],
      homePageFieldsArray: [],
      // hrStatus: 0,
      homePaymentPlanFields: [],
      homeSelectedPaymentPlan: '',
      homeCarrierFinalRateSection: [],
      // driversIncidentsArray: [],
      // finalDriversIncidents: [],
      homeCarrierPaymentInformationSection: [],
      homeblurbs: [],
      homeColsArray: [],
      homePropCov: [],
      homePropEndsmt:[],
      // vehCov: [],
      homePageData: {
        page_name: '',
        tab_buttons:[],
        buttons: [],
        fields: [],
        homeblurbs: [],
        quote_summary: {},
      },
      homeCurrentPaymentFieldsOrder: [],
      homeVgsForm: false,
      homeVgsStatus: {
        isVgsFormReady: false,
        hasLoaded: {
          credit_card: false,
          bank_account: false,
          bank_account_installment: false,
          card_cvc: false,
          credit_card_installment: false,
          card_cvc_installment: false,
          loan_number:false,
        },
        active: {
          credit_card: false,
          bank_account: false,
          bank_account_installment: false,
          card_cvc: false,
          credit_card_installment: false,
          card_cvc_installment: false,
          loan_number:false,
        },
        keys: {
          QTE_PRP_CreditCardNumber: 'cc',
          QTE_PRP_BankAccountNumber: 'ba',
          QTE_PRP_BankAccountNumberInstallment: 'bai',
          QTE_PRP_CreditCardCvv: 'cvv',
          QTE_PRP_CreditCardNumberInstallment: 'cci',
          QTE_PRP_CreditCardCvvInstallment: 'cvvi',
          QTE_PRP_MTG_0_HomeLoanNumber:'ln'
         
        },
        indexes: {
          QTE_PRP_CreditCardNumber: 1,
          QTE_PRP_BankAccountNumber: 3,
          QTE_PRP_BankAccountNumberInstallment: 4,
          QTE_PRP_CreditCardCvv: 2,
          QTE_PRP_CreditCardNumberInstallment: 5,
          QTE_PRP_CreditCardCvvInstallment: 6,
          QTE_PRP_MTG_0_HomeLoanNumber:7,
        },
        prevState: {
          QTE_PRP_CreditCardNumber: false,
          QTE_PRP_BankAccountNumber: false,
          QTE_PRP_BankAccountNumberInstallment: false,
          QTE_PRP_CreditCardCvv: false,
          QTE_PRP_CreditCardNumberInstallment: false,
          QTE_PRP_CreditCardCvvInstallment: false,
          QTE_PRP_MTG_0_HomeLoanNumber:false
        },
        qrpFieldNames: {
          QTE_PRP_CreditCardNumber: 'credit_card',
          QTE_PRP_BankAccountNumber: 'bank_account',
          QTE_PRP_BankAccountNumberInstallment: 'bank_account_installment',
          QTE_PRP_CreditCardCvv: 'card_cvc',
          QTE_PRP_CreditCardNumberInstallment: 'credit_card_installment',
          QTE_PRP_CreditCardCvvInstallment: 'card_cvc_installment',
          QTE_PRP_MTG_0_HomeLoanNumber:'loan_number'
        },
      },
      homecollect: false,
      routerInfo:{
        from:'',
        to:''
      },      
      HOQuoteId : JSON.parse(sessionStorage.getItem('homeSessionData')).SessionId,
      showError: false,
      homeBundleCarrierError : {
        msg: '',
        showCarrierLogo: true,
        logoPathSvg: JSON.parse(sessionStorage.getItem('selectedCarrierHome')).logoPathSvg,
        carrier_name: JSON.parse(sessionStorage.getItem('selectedCarrierHome')).carrier_name
      }
    }
  },
  components: {
    // SectionNavigation,
    Trap,
    FormBlock,
    FormAlerts,
    InputLinkButtonList,
    BundleCarrierError
  },
  created() {
    this.$store.dispatch('setRCHomeError', false);
    this.$store.dispatch('setRCHomeErrorDesc', "");
    this.$store.commit('setHomeVgsIndexes', this.homeCurrentPaymentFieldsOrder);
    // call vgsLoaderAzure
    this.vgsLoaderAzure();  
    const getUrl = `/pages/HORateCall2Details/${this.HOQuoteId}`;
 
// });
 //this.homePageData = this.fallbackData();
    this.$root.$off("load-cc-home");
    this.$root.$off("load-ba-home");
    this.$root.$off("load-bai-home");
    this.$root.$off("load-cvv-home");
    this.$root.$off("load-cci-home");
    this.$root.$off("load-cvvi-home");
    this.$root.$off("load-ln");
    

},
 beforeMount() {
    //Taking value from session once store(Vuex) getting reset on page refresh
    if(this.$store.getters.homeRc2Nav.page_name ==='null' || this.$store.getters.homeRc2Nav.page_name===null){
     const pagenameFromSession= sessionStorage.getItem("sethomeRc2Nav");
     this.$store.dispatch('sethomeRc2Nav',pagenameFromSession);
    }
   if(this.$store.getters.finalNavData.length === 0)
    {  
       if(sessionStorage.getItem("setfinalNavDataAction")){
        const finalNavfromSession=JSON.parse(sessionStorage.getItem("setfinalNavDataAction"));
        this.$store.dispatch('setfinalNavDataAction', finalNavfromSession);
       }
    }
   
  },
 mounted() {
    this.initializePageData();
    this.$store.commit('setHomeVgsIndexes', this.homeCurrentPaymentFieldsOrder);
    this.$root.$on("load-cc-home", this.loadVgsField);
    this.$root.$on("load-ba-home", this.loadVgsField);
    this.$root.$on("load-bai-home", this.loadVgsField);
    this.$root.$on("load-cvv-home", this.loadVgsField);
    this.$root.$on("load-cci-home", this.loadVgsField);
    this.$root.$on("load-cvvi-home", this.loadVgsField);
    this.$root.$on("load-ln", this.loadVgsField);
      
  this.routerInfo.from = sessionStorage.getItem("currentRc2FromNav");
  this.routerInfo.to = sessionStorage.getItem("currentRc2ToNav");
 },
 watch: {
    'showError' : function(newValue, oldValue) {
      if (newValue === true) {
        var element = document.getElementById("homeCol");
        element.classList.remove("bound");
      }
    },
    'homeCurrentPaymentFieldsOrder' : function(newValue, oldValue) {
      this.$root.$emit('homeCurrentPaymentFieldsOrderUpdate', this.homeCurrentPaymentFieldsOrder);
    },
    'routerInfo.from' : function(newValue, oldValue) {
     this.getStatusForNav(this.routerInfo);
    },
    homeVgsForm: function (newValue) {
      if (newValue !== false) {
        this.homeVgsStatus.isVgsFormReady = true;
      }
      this.$root.$emit('homeVgsFormUpdate', this.homeVgsForm);
    },
    'homePageData.tab_buttons': function (newValue, oldValue) {
      this.homePageData.tab_buttons=this.$store.getters.finalNavData;
     }, 
    'homePageData.fields': function (newValue, oldValue) {
      /*
        Check for changes in visibility of any of the payment fields. If true, then all vgs fields must be reinitialized due to possible array index offsets.
      */
      this.$root.$emit('homePageDataUpdate', this.homePageData);
      if (this.homePageData.fields && this.homePageData.fields.length > 0) {
        let shouldReinit = false;
        this.homePageData.fields.forEach(e => {
          if (this.homeVgsStatus.prevState.hasOwnProperty(e.field_name)) {
            if (this.homeVgsStatus.prevState[e.field_name] !== e.visible) {
              shouldReinit = true;
            }
            this.homeVgsStatus.prevState[e.field_name] = e.visible
          }
        })

        if (shouldReinit) {
          this.reinitializeVgsFields();
        }
      }
    },
     beforeDestroy() {
      this.$root.$off("load-cc-home");
      this.$root.$off("load-ba-home");
      this.$root.$off("load-bai-home");
      this.$root.$off("load-cvv-home");
      this.$root.$off("load-cci-home");
      this.$root.$off("load-cvvi-home");
      this.$root.$off("load-ln");
      this.$store.commit('setHomeVgsIndexes', []);
    }
     
  },
 methods: {
  // redirect to param url and open in new tab
  homeRedirectToCoverage(redUrl) {
    window.open(redUrl, '_blank');
  },
  /* return static content for checkout section 
  */
  homeInfoContent() {
    return "Click the checkout button below to finish binding the policy on the carrier's portal.";
  },
  isPolicyBound() {
    return (this.homePageData.quote_summary && this.homePageData.quote_summary.quote_status === 'Bound'); // TODO: Use config values
  },
  initializePageData() {
      this.homePageData.tab_buttons = [];
      const requestParam = {
        url: `/pages/HOBindCallDetails/${this.HOQuoteId}`,

      };
      fetchData.getPageData(requestParam).then((response) => {

        // log API response time through application into GA tool
        const startTimeVal = (new Date()).getTime();
        common.gapRecordAnalyticsGeneric(startTimeVal, 'API', response.data.page_name);
        this.homePageData = response.data;
        sessionStorage.setItem('homePageName', response.data.page_name);
        this.$root.$emit('homePageDataUpdate', this.homePageData);
        this.homePageData.tab_buttons = [];
        const finalNavData = this.$store.getters.finalNavData;
        
        this.$store.commit('setHomeBindStatus', response.data.quote_summary.quote_status);
        if (response.data.quote_summary.quote_status === 'Bound') {
          let bindStatus = {
            'Status' : 'Success',
          };
          this.$store.commit('setHomeBindStatus', bindStatus);
          finalNavData.forEach(nav => {
            if (nav.section === 'RC1' || nav.status === 'Disabled') {
              nav.status = 'InactiveComplete'
            }
          });
          Object.assign(this.homePageData.tab_buttons, finalNavData);
        } else {
          let bindStatus = {
            'Status' : response.data.quote_summary.quote_status,
          };
          this.$store.commit('setHomeBindStatus', bindStatus);
          Object.assign(this.homePageData.tab_buttons, finalNavData);
        }
        if (this.homePageData.fields && this.homePageData.fields.length > 0) {
          this.homePageFieldsArray = this.homePageData.fields;
          this.homePaymentPlanFields = this.homePageData.payment_plan_fields;
          this.homeCarrierFinalRateSection = this.homePageData.carrier_final_rate_section;
          this.homeCarrierPaymentInformationSection = this.homePageData.carrier_payment_information_section;
          this.homeSelectedPaymentPlan = Object.values(this.homePageFieldsArray).filter(obj => obj.field_name === 'QTE_PRP_BillPlan')[0].field_value;
          this.homePropCov = this.homePageData.coverage_summary && this.homePageData.coverage_summary.propertyCoverages ? this.homePageData.coverage_summary.propertyCoverages : []; 
          this.homePropEndsmt = this.homePageData.coverage_summary && this.homePageData.coverage_summary.propertyEndorsements ? this.homePageData.coverage_summary.propertyEndorsements : [];
          for (let cnt = 0; cnt < this.homePageData.fields.length; cnt += 1) {
            if (this.homePageData.fields[cnt].field_type === 'LinkButtonList' && this.homePageData.fields[cnt].section !== 'Billing Information') {
              this.homePdfLinkCov.push(this.homePageData.fields[cnt]);
              sessionStorage.setItem('homePdfLinkCov', JSON.stringify(this.homePdfLinkCov));
            }
            if (this.homePageData.fields[cnt].field_name === 'QTE_CAR_CarrierURL' && this.homePageData.fields[cnt].visible === true) {
              this.$store.commit('setHomeLinkButtunStatus', true);
            }
          }
          // set coliumns 1 and 2 using homePageFieldsArray
          this.homePageFieldsArray.forEach((element) => {
            if (!this.homeColsArray.find(el => el === element.section)) {
              this.homeColsArray.push(element.section);
            }
            if (element.section === 'Coverage Summary & Approval' && element.field_type !== 'label') {
              this.homeAcknowledgementSection = true;
            }
          });
          if (this.homeColsArray.find(el => el === 'Billing Information')) 
            this.homeBllingInformationSection = true;
            else
            this.homeBllingInformationSection = false;

          if (this.homeColsArray.find(el => el === 'Checkout'))
            this.homeCheckoutSection = true;
          else
            this.homeCheckoutSection = false;

          // store homeSelectedPaymentPlan in vuex state and retrieve in InputRadioSingle.vue component
          this.$store.dispatch('setSelectedHomePaymentMethod', this.homeSelectedPaymentPlan);
          this.$store.dispatch('setHomeBillingPlan', this.homeSelectedPaymentPlan);
          this.$store.commit('setHomeRC2Status', 'success');
          if (this.homePaymentPlanFields.length == 0 && response.data.quote_summary.quote_status === 'Bound') {
            var element = document.getElementById("homeCol");
            element.classList.remove("bound");
            this.showError = true;
            this.homeBundleCarrierError.forceBind = true;
            this.homeBundleCarrierError.msg = '<strong>Policy Bound:</strong> This policy has been completed and bound. Any attempted changes to this policy will not be saved. Contact your manager if this policy was saved with incorrect information.';
          }
        } else {
          this.showError = true;
          this.homeBundleCarrierError.msg = this.homePageData.Error.Message;
          this.$store.commit('setHomeRC2Status', 'error');
        }
        
      })
    },
   /**
     * get display value from back end value
     */
    getAnswerOption(rData) {
      for (let rCnt = 0; rCnt < rData.values.length; rCnt += 1) {
        if (rData.field_value === rData.values[rCnt].internal_value) {
          return rData.values[rCnt].display_value;
        }
      }
      return '';
    },
    /**
     * Get policy start date
     */
    getPolicyStartDate() {
      let startDate = '';
      if (this.homePageData.fields && this.homePageData.fields.length > 0) {
        for (let cnt = 0; cnt < this.homePageData.fields.length; cnt += 1) {
          if (this.homePageData.fields[cnt].field_name === 'QTE_PRP_NewPolicyStartDate') {
            startDate = this.homePageData.fields[cnt].field_value;
            break;
          }
        }
      }
      return moment(startDate, 'YYYYMMDD').format('MM/DD/YYYY');
    },
    newHeader(key, homePaymentPlanFields, itemSubsection) {
      let visibilityCheck = false;
      for (let pCnt = 0; pCnt < homePaymentPlanFields.length; pCnt += 1) {
        if (itemSubsection === homePaymentPlanFields[pCnt].sub_section && homePaymentPlanFields[pCnt].visible) {
          visibilityCheck = true;
          break;
        }
      }
      let previousSubSection;
      if (key !== 0) {
        previousSubSection = homePaymentPlanFields[key - 1].sub_section;
        // console.log('3', homePaymentPlanFields[key-1].sub_section);
      } else {
        previousSubSection = '';
      }

      if (previousSubSection !== homePaymentPlanFields[key].sub_section && visibilityCheck) {
        return true;
      }
      return false;
    },
    newHeaderNoVisibilitycheck(key, homePaymentPlanFields) {
      let previousSubSection;
      if (key !== 0) {
        previousSubSection = homePaymentPlanFields[key - 1].sub_section;
        // console.log('3', homePaymentPlanFields[key-1].sub_section);
      } else {
        previousSubSection = '';
      }

      if (previousSubSection !== homePaymentPlanFields[key].sub_section) {
        return true;
      }
      return false;
    },
    // TODO: Remove after development is complete.
    isHide()
    { 
      return false;;
    },
     isBlue(section) {
      if (section === 'Monthly Payment') {
        return true;
      }
      return false;
    },
  
    fallbackData() {
      return fallbackDataRc3;
    },

    getStatusForNav(inRouterInfo){
      let fromNav = inRouterInfo.from;
      let temp=[];
      let navStatusObj= {
        page_name:'',
        status:'',
      };
      let toNavStatusObj ={
        page_name:'',
        status:'',
      };
      let navStatuses=[];
      toNavStatusObj.page_name = inRouterInfo.to;
      toNavStatusObj.status='InactiveComplete';
      navStatusObj.page_name=fromNav;
      navStatusObj.status='InactiveComplete';
      navStatuses[0] = navStatusObj;
      navStatuses[1] = toNavStatusObj;
      this.$store.dispatch('setNavStatusAction', navStatuses);
    },
//Starting VGS 
  async vgsLoaderAzure() {
      await loadVGSCollect({
        vaultId: process.env.VGS_VAULT_ID_AZURE,
        environment: process.env.VGS_ENV,
        version: '2.8.0',
      })
        .then((homecollect) => {
          this.homecollect = homecollect;
        })
        .catch((e) => {
          console.log(e);
        });

      // https://www.verygoodsecurity.com/docs/vgs-collect/js/integration#form-state
      this.homeVgsForm = this.homecollect.init((state) => {
        // console.log('HomeCollect State', state);
      });
      this.homeVgsForm.useCname(process.env.VGS_CNAME_AZURE);
    },
    loadVgsField(targetId, fieldSettings, vgsName) {
     this.homeVgsStatus.hasLoaded[vgsName] = this.homeVgsForm.field(targetId, fieldSettings);
    },
    // reinitializes due to changes in the expected final array indexes of the POST's "fields" property.
    reinitializeVgsFields() {
      if (this.homePageData.fields) {
        // verify visible fields
        let onlyVisiblePayments = this.homePageData.fields.filter((el) => {
          return this.homeVgsStatus.qrpFieldNames[el.field_name] && (el.visible == true);
        })
        onlyVisiblePayments.sort((a, b) => {
          return a.field_name - b.field_name;
        });

        onlyVisiblePayments.forEach((el, i) => {
          // each vgs payment component (e.g., InputCreditcard.vue) will be re-rendered with an updated index value
          this.homeVgsStatus.indexes[el.field_name] = i;
          // triggers re-render to reinitialize field with updated corresponding "homeVgsStatus.indexes" value
          this.homeVgsStatus.keys[el.field_name] += "refresh";
        });

        // homeCurrentPaymentFieldsOrder is used in the vgsNavigationFormPost() method to ensure that the "front array" is identical regarding order of fields
        // this is important as the vgs fields (e.g., InputCreditcard.vue) has to be initialized with the expected array index location of the
        // corresponding field_value property sent in the payload. Incorrect indexes will mismatch the data.
        this.homeCurrentPaymentFieldsOrder = this.homeVgsStatus.indexes;
        this.$store.commit('setHomeVgsIndexes', this.homeCurrentPaymentFieldsOrder);
      } else {
        console.log('Fields value is empty.');
      }
    }
//Ending VGS

 }
}
</script>
<style scoped lang="scss">
.alert-danger {
  padding: 16px 16px 16px 24px;
  .fa-icon-exclamation-circle {
    background-color: #BB0000;
    height: 25px;
    width: 25px;
  }
}
.payment-error {
  word-break: break-all;
}
.bg-homeback{
    background-color: $var-home-bg !important;
}
.bg-light {
  background-color: $var-input-icon-background !important;
}
.text-faint-gray {
  color: $var-color-faint-gray;
} 
.bg-primary {
  background-color: $var-color-header-auto-icon !important;
}
.bg-checkout-header {
  background-color: $var-color-chkout-bg-darkgray;
}
.exclmn-icon {
  color: $var-color-qs-white;
}
.exclmn-icon-bg {
  color: $var-color-dark-yellow;
}
h3{
  font-size: 1.5rem;
}

.border-thick{
  border: 4px solid;
}
.text-black {
color: $var-input-icon-color !important;
}
.text-gray{
  color: $var-color-grey-knockout !important;
}
.text-qs-blue {
  color: $var-color-qs-blue !important;
}

.text-green{
  color: $var-success-green !important;
}

.bg-gray{
  background-color: $var-color-nav-auto-bg !important;
}
.text-dark-gray {
  color: $var-color-graydark;
}
.bg-driver-inc {
  background-color: $var-color-faint-yellow !important;
}
.bg-yellow{
  background: #FFD500 !important;
}
.text-danger-checkout {
color: $var-color-danger;
}
.bg-green{
  background: $var-success-green !important;
}

.bg-danger{
  background: #BB0000 !important;
  .fa-icon-exclamation-circle {
    background-color: #ffffff;
    width: 18px;
    height: 18px;
    position: relative;
    top: 3px;
  }
}

.border-green{
  border-color: $var-success-green !important;
}

.smaller-font-content{
  line-height: 1rem;
}

/**SECTION HEADER w/ ICON**/
.uniform-icon-size{
  font-size: .7rem;
}

/**RATE & QUOTE SECTION**/
.final-rate{
  font-size: 2.5rem;
  letter-spacing: -1px;
}

.quote{
  font-size: 1.5rem;
  letter-spacing: -1px;
}

.quote-adjust ul{
  padding-left: 1.5rem;
}

.sm-txt{
  font-size: 0.6875rem;
  line-height: 0.8125rem;
}

/**INCIDENT SECTION**/
.incident-item, .payment-item{
  border-top: 1px solid #DEE2E6;
}

.plusminus.active::before {
  content: ' \2013';
}

.plusminus.inactive::before {
  content: ' \002B';
}

#driver-incidents-collapse-click {
  cursor: pointer;
}

div.breakdown-modal-top h3,
#consumer-disclosure-para-holder,
.plusminus{
  font-size: 1rem;
}

.uniform-icon-breakdown {
  font-size: .7rem;
  float: right;
}

.breakdown-modal-header {
  display: inline-block;
}

#next-step-para {
  color: #BB0000;
}

/**INSTALLMENT BREAKDOWN MODAL**/
#reporting-agency-content,
#error-next-step-container,
.breakdown-table-body,
#no-incidents-msg{
  font-size: 12px;
}

.v--modal img.carrier-logo{
  width: 100%;
  height: inherit !important;
  max-width: 200px;
}
.btn-outline-primary-checkout {
  color: $var-qs-dark-blue;
  border-color: $var-qs-dark-blue;
}


.card-header {
  background-color: $var-color-home-icon;
  .btn {
    background-color: $var-color-home-icon;
    text-align: left;
    border-color: $var-color-home-icon !important;
    padding-left: 8px;
    &:hover, &:focus {
      background-color: $var-color-home-icon !important;
      color: #ffffff;
      border-color: $var-color-home-icon !important;
      box-shadow: none !important;
    }
  }
}
.card-body {
  padding: 16px;
}

.card-heading {
  text-align: left;
  text-transform: capitalize;
  font-size: 0.875rem;
  line-height: 21px;
  .fas.fa-home {
    font-size: 18px;
    position: relative;
    top: 1px;
  }
}

.toggle-icon {
  display: block;
  cursor: pointer;
}

.toggle-icon {
  float: right;
}

.toggle-icon .toggle-up  {
  display: inline-block;
}

.toggle-icon .toggle-down {
  display: none;
}

.collapsed {
  .toggle-icon .toggle-down {
    display: inline-block;
  }

  .toggle-icon .toggle-up {
    display: none;
  }
}
</style>
<style>
.vgs-span {
  width: 100%;
}
.vgs-span IFRAME {
  width: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/interview/shared/HomeCheckout.vue?8c136386